import { render, staticRenderFns } from "./Remarketing.vue?vue&type=template&id=6d388999&scoped=true"
import script from "./Remarketing.vue?vue&type=script&lang=js"
export * from "./Remarketing.vue?vue&type=script&lang=js"
import style0 from "./Remarketing.vue?vue&type=style&index=0&id=6d388999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d388999",
  null
  
)

export default component.exports